import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const WeightLoss: FC = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<string>("");

  const handleNext = () => {
    // Convert to Django choice keys
    let backendValue;
    if (selectedOption === "Yes") {
      backendValue = "yes";
    } else if (selectedOption === "No") {
      backendValue = "no";
    } else if (selectedOption === "Not Sure") {
      backendValue = "not_sure";
    }

    // Save weight loss preference to session storage
    SessionStorageHelper.saveField("weight_loss_goal", backendValue);

    // Navigate based on selection
    if (selectedOption === "Yes") {
      // If Yes, go to Target Weight page first
      navigate("/glucera" + GluceraNavigationRoutes.TARGET_WEIGHT);
    } else {
      // If No or Not Sure, clear weight_loss_reasons and go to Workout page
      SessionStorageHelper.saveField("weight_loss_reasons", null);
      SessionStorageHelper.saveField("target_weight_in" as any, null);
      SessionStorageHelper.saveField("target_weight_kg" as any, null);
      SessionStorageHelper.saveField("target_weight_lbs" as any, null);
      navigate("/glucera" + GluceraNavigationRoutes.WORKOUT_PAGE);
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 7 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-6 space-y-2">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              Weight Loss Goal
            </h1>
            <p className="text-sm text-muted-foreground">
              Are you currently trying to lose weight as part of your health
              goals?
            </p>
          </div>

          <div className="mb-6 space-y-3">
            {["Yes", "No", "Not Sure"].map(option => (
              <Card
                key={option}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selectedOption === option
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedOption(option)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-lg font-semibold">{option}</span>
                  <RadioDot selected={selectedOption === option} />
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container */}
          <div className="mt-auto">
            <Button
              onClick={handleNext}
              disabled={!selectedOption}
              className={gluceraAssessmentCta}
            >
              {selectedOption ? "Next" : "Select Option"}
            </Button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default WeightLoss;
